module.exports = __webpack_public_path__ + "img/Malak Al Mawt.8c0ee036.png";